import { Button, Input, Modal, Space, Typography } from "antd"
import { useState } from "react"

const ChangePasswdModal = ({
    isOpen,
    onClose,
    onUpdate
}) => {
    const [passwd, setPasswd] = useState("");
    const isValid = passwd.length >= 8;

    const handleUpdate = () => {
        if (isValid && onUpdate) {
            onUpdate(passwd);
            setPasswd("");
            onClose();
        }
    };

    return <Modal
        title="Update pasword key"
        open={isOpen}
        onCancel={onClose}
        footer={null}
    >
        <Space >
            <h3>New Password:</h3>
            <Input placeholder="Enter new password" value={passwd} onChange={(e) => setPasswd(e.target.value)}></Input>
            <Button
                type="primary"
                onClick={handleUpdate}
                disabled={!isValid}
            >Update</Button>
        </Space>
        <br></br>
        {!isValid && passwd.length > 0 && (
            <Typography.Text type="warning">
                Password must be at least 8 characters
            </Typography.Text>
        )}
    </Modal>
}

export default ChangePasswdModal